import styled from 'styled-components';

export const SidebarItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => (props.selected ? '#e9f0f7' : '#fff')};
  cursor: pointer;
  font-size: 13px;
  min-height: 50px;
  overflow: hidden;
  white-space: nowrap;
  padding: 3px 10px;
  border-bottom: 1px solid #f2f2f2;
  transition: background .3s ${props => (props.selected ? 'ease-in' : 'ease-out')};
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const SidebarItemHeader = styled.div`
  display: flex;
`;

export const SidebarItemTitle = styled.div`
  font-weight: bold;
  font-size: 12px;
  height: 100%;
  line-height: 24px;
`;

export const SidebarItemImage = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  min-width: 16px;
  min-height: 16px;
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
`;

export const SidebarItemSubtitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  color: #0052cc;
  
  &:hover,
  &:focus {
    color: #0049b0;
    text-decoration: underline;
  }
`;
